// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.touring.SatelliteWebLandlordTouringHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  SatelliteWebLandlordGetTourForConversationIdRequestDto,
  SatelliteWebLandlordGetTourForConversationIdResponseDto,
  SatelliteWebLandlordGetTouringTreatmentForListingRequestDto,
  SatelliteWebLandlordGetTouringTreatmentResponseDto,
  SatelliteWebLandlordPerformTourActionRequestDto,
  SatelliteWebLandlordPerformTourActionResponseDto,
  SatelliteWebLandlordScheduleTourRequestDto,
  SatelliteWebLandlordScheduleTourResponseDto,
} from '../..';

export const SatelliteWebLandlordTouringHandler_getTourForConversationId_Path =
  '/api/web/landlord/v1/touring/scheduling/getTourForConversationId';

/**
 * Get tour for satellite conversation id via z-calendar service
 */
export const SatelliteWebLandlordTouringHandler_getTourForConversationId = (
  postData: SatelliteWebLandlordGetTourForConversationIdRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordGetTourForConversationIdRequestDto,
    SatelliteWebLandlordGetTourForConversationIdResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordTouringHandler_getTourForConversationId_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing_Path =
  '/api/web/landlord/v1/touring/getTouringTreatmentForListing';

/**
 * Get touring treatment for listing via z-calendar service
 */
export const SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing = (
  postData: SatelliteWebLandlordGetTouringTreatmentForListingRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordGetTouringTreatmentForListingRequestDto,
    SatelliteWebLandlordGetTouringTreatmentResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordTouringHandler_getTouringTreatmentForListing_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordTouringHandler_performTourAction_Path =
  '/api/web/landlord/v1/touring/scheduling/performTourAction';

/**
 * Perform a tour action as a landlord via z-calendar service
 */
export const SatelliteWebLandlordTouringHandler_performTourAction = (
  postData: SatelliteWebLandlordPerformTourActionRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordPerformTourActionRequestDto,
    SatelliteWebLandlordPerformTourActionResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordTouringHandler_performTourAction_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordTouringHandler_scheduleTour_Path =
  '/api/web/landlord/v1/touring/scheduling/scheduleTour';

/**
 * Add a tour the landlord negotiated with the renter
 */
export const SatelliteWebLandlordTouringHandler_scheduleTour = (
  postData: SatelliteWebLandlordScheduleTourRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordScheduleTourRequestDto,
    SatelliteWebLandlordScheduleTourResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordTouringHandler_scheduleTour_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};
